import { render, staticRenderFns } from "./RechargeDetail.vue?vue&type=template&id=6933bdaa&scoped=true"
import script from "./RechargeDetail.vue?vue&type=script&lang=js"
export * from "./RechargeDetail.vue?vue&type=script&lang=js"
import style0 from "./RechargeDetail.vue?vue&type=style&index=0&id=6933bdaa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6933bdaa",
  null
  
)

export default component.exports